export default __webpack_public_path__ + "static/media/eid.e68a9863.jpg";